module.exports = __webpack_public_path__ + "static/3-352e2740d59b1eda5366d292ca261de5.png";